<div class="dashboard-container" *ngIf="showData; else noData">
	<div class="column">
		<div class="card perf-box" *ngIf="truckAhPercentages.length">
			<div class="perf-sect">
				<h2 class="perf-label">{{'truck_reports.truck_in_use_performance' | translate}}</h2>
				<div class="perf-graph">
					<div class="perf-rows" *ngFor="let data of truckAhPercentages">
					<div class="p-row" *ngFor="let bucket of ['76-100%+', '51%-75%', '26%-50%', '0%-25%']">
						<span>{{ bucket }}</span>
						<div class="bar-container">
						<div 
							class="p-bar"
							[ngClass]="{
								'bg-green': bucket === '76-100%+',
								'bg-yellow': bucket === '51%-75%',
								'bg-orange': bucket === '26%-50%',
								'bg-red': bucket === '0%-25%'
							}"
							[style.width]="clampPercent(data.percentages[bucket])">
						</div>
						<span class="percent-text">{{ data.percentages[bucket] }}%</span>
						</div>
					</div>
					</div>
				</div>
			</div>
			<div class="perf-sect" *ngIf="endVoltagePercentages.length">
				<h2 class="perf-label">{{'truck_reports.in_use_end_voltages' | translate}}</h2>

				<div class="perf-graph">
					<div class="perf-rows" *ngFor="let data of endVoltagePercentages">

						<div class="p-row">
							<span>> 1.9 VPC</span>
							<div class="bar-container">
								<div class="p-bar bg-green"
									[style.width]="clampPercent(data.percentages.high)">
								</div>
								<span class="percent-text">{{ data.percentages.high }}%</span>
							</div>
						</div>

						<div class="p-row">
							<span>1.80 - 1.9 VPC</span>
							<div class="bar-container">
								<div class="p-bar bg-yellow"
									[style.width]="clampPercent(data.percentages.mid)">
								</div>
								<span class="percent-text">{{ data.percentages.mid }}%</span>
							</div>
						</div>

						<div class="p-row">
							<span>< 1.80 VPC</span>
							<div class="bar-container">
								<div class="p-bar bg-red"
									[style.width]="clampPercent(data.percentages.low)">
								</div>
								<span class="percent-text">{{ data.percentages.low }}%</span>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="perf-sect" *ngIf="travelLiftPercentages.length && (device.config_info != application_type.BOAT || device.config_info != application_type.GOLF_CART)">
				<h2 class="perf-label">{{'truck_reports.travel_lift_time' | translate}}</h2>
				<div class="perf-graph">
					<div class="perf-rows" *ngFor="let data of travelLiftPercentages">
						<div class="p-row">
							<span>{{'truck_reports.travel_time' | translate}}</span>
							<div class="bar-container">
								<div class="p-bar bg-blue"
									[style.width]="clampPercent(data.travel)">
								</div>
								<span class="percent-text">{{ data.travel }}%</span>
							</div>
						</div>
						<div class="p-row">
							<span>{{'truck_reports.lift_time' | translate}}</span>
							<div class="bar-container">
								<div class="p-bar bg-orange"
									[style.width]="clampPercent(data.lift)">
								</div>
								<span class="percent-text">{{ data.lift }}%</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #noData>
	<div class="mt-4 pl-3 pr-3">
		<div class="alert alert-info">
		{{ 'g.no_data_to_show' | translate }}
		</div>
	</div>
</ng-template>